<template>
    <div>
        <a-icon
            class="menu-trigger"
            v-on:click="openDrawer"
            :type="iconStyle"
            :style="{
                color: '#ffffff'
            }"
        >

        </a-icon>
        <a-drawer
            title="Akciók"
            placement="left"
            :closable="true"
            v-on:close="closeDrawer"
            :visible="drawerOpen"
        >
            <a-menu
                v-model="currentMenu"
            >
                <a-menu-item
                    v-for="menuItem of roleFilteredMenu"
                    :key="menuItem.key"
                >
                    <a-icon :type="menuItem.icon" />
                    {{ menuItem.title }}
                </a-menu-item>
            </a-menu>
        </a-drawer>
    </div>
</template>

<script>
import { USER_LOGOUT, STOP_TIMER } from '../../../store/action_types';
export default {

    data() {
        return {
            drawerOpen: false,
            menuElems: [
                {
                    key: 'new_info',
                    icon: 'file-add',
                    title: 'Új Infó',
                    roles: []
                },
                {
                    key: 'new_akta',
                    icon: 'folder-add',
                    title: 'Új Akta',
                    roles: ['ROLE_ADMIN', 'ROLE_ADVANCED_USER']
                },
                {
                    key: 'aktas',
                    icon: 'search',
                    title: 'Akta Kereső',
                    roles: ['ROLE_ADMIN', 'ROLE_ADVANCED_USER']
                },
                {
                    key: 'infos',
                    icon: 'file-search',
                    title: 'Infó Kereső',
                    roles: []
                },
                {
                    key: 'settings',
                    icon: 'setting',
                    title: 'Beállítások',
                    roles: ['ROLE_ADMIN']
                },
                {
                    key: 'login',
                    icon: 'logout',
                    title: 'Kijelentkezés',
                    roles: []
                }
            ]
        }
    },
    
    computed: {
        iconStyle() {
            return this.drawerOpen ? 'menu-fold' : 'menu-unfold'
        },
        roleFilteredMenu() {
            const filteredMenu = this.menuElems.filter(el => {
                if (el.roles.length > 0) {
                    console.log(el.roles);
                    return el.roles.some(role => {
                        const roleFound = this.$store.getters.getRole(role)
                        return roleFound;
                    })
                } else {
                    return true;
                }
            })
            return filteredMenu;
        },
        currentMenu: {
            get() {
                let currentMatched = [];
                menuLoop:
                for (let i = 0; i < this.menuElems.length; i++) {
                    const menuName = this.menuElems[i].key;
                    for (let j = 0; j < this.$route.matched.length; j++) {
                        if (menuName === this.$route.matched[j].name) {
                            currentMatched.push(menuName);
                            break menuLoop;
                        }
                    } 
                }
                return currentMatched;
            }, 
            set(val) {
                if (val[0] === 'login') {
                    this.$store.dispatch({
                        type: STOP_TIMER
                    })
                    this.$store.dispatch({
                        type: USER_LOGOUT
                    })
                }
                this.$router.push({
                    name: val[0]
                })
                this.closeDrawer();
            }
        }
    },

    methods: {
        openDrawer() {
            this.drawerOpen = true;
        },
        closeDrawer() {
            this.drawerOpen = false;
        }
    }

}
</script>

<style lang="scss" scoped>
    .menu-trigger {
        font-size: 18px;
        line-height: 64px;
        padding: 0 24px;
        cursor: pointer;
        transition: color .3s;

        &:hover {
            color: rgba(255, 255, 255, 0.781);
        }
    }
</style>
